/** 角色类型 */
export const TabType = {

    /** 企业对账单 */
    Reconciliation: 'Reconciliation',

    /** 企业交易明细 */
    TransactionDetail: 'TransactionDetail',

    /** 企业对账周期 */
    ReconciliationCycle: 'ReconciliationCycle'

};

/** 对账单列表字段 */
export const ReconciliationFeilds = {

    /** 标识 */
    id: 'id',

    /** 企业名称 */
    enterpriseName: 'targetName',

    /** 开始时间 */
    startTime: 'startTime',

    /** 结束时间 */
    endTime: 'endTime',

    /** 对账金额 */
    amount: 'settleAmount',

    /** 状态 */
    state: 'verifyStatus',
    stateDesc: 'verifyStatusName',

    /** 生成时间 */
    createTime: 'gmtCreate'
};

/** 对账单详情页面字段 */
export const ReconciliationDetailFields = {

    /** 业务单号 */
    businessId: 'orderId',

    /** 业务名称 */
    businessName: 'orderTypeName',

    /** 交易名称 */
    transactionName: 'costName',

    /** 金额（元） */
    money: 'amount',

    /** 交易时间 */
    transactionTime: 'orderPayTime',

    /** 交易账号 */
    transactionAccount: 'orderPayUser',

    /** 支付方式 */
    payType: 'orderPayTypeName'

};

/** 交易明细字段 */
export const TransactionDetailFields = {
    /** 交易时间 */
    transactionTime: 'transTime',

    /** 账户外部编号 */
    accountOutId: 'accountId',

    /** 账户名称 */
    accountName: 'companyName',

    /** 子账户名称 */
    subAccountName: 'transAccNo',

    /** 交易名称 */
    transactionName: 'transTypeName',

    /** 收支类型 */
    incomeDrawType: 'loanTypeName',

    /** 交易金额（元） */
    transactionMoney: 'transAmount',

    /** 交易后余额（元） */
    transactionBalance: 'remainBalance',

    /** 支付订单号 */
    payOrderId: 'payId',

    /** 业务订单号 */
    businessOrderId: 'orderId',

    /** 业务来源 */
    businessSource: 'bizSource'
};


export const ReconciliationCycleFields = {
    id: 'id',

    /** 手机号码 */
    tel: 'tel',

    /** 企业名称 */
    enterpriseName: 'epName',

    /** 对账周期 */
    reconciliationCycle: 'reconciliationDay',

    /** 注册时间 */
    createTime: 'epRegisterTime'

};
